<template>
  <div class="row">
    <div class="col-md-12 py-md-2 py-2">
      <div class="row pt-md-3 pt-0 mb-2 h-100">
        <div class="col-md-6 col-12 my-auto text-center">
          <div class="home_intro">Watch Your Website Visitors Live</div>
          <div class="mt-3" style="font-size: 1.1rem">
            Separate human and bot visitors automatically
          </div>
          <div class="mt-4 pt-2 pb-4 mb-4">
            <start-project :auth="auth" page="home"></start-project>
          </div>
        </div>
        <div class="col-md-6 col-12 text-center">
          <video controls poster="/images/supalytic-1080p-251014-0.jpg" width="100%" style="border-radius:10px;">
            <source src="/videos/supalytic-1080p-251014.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <!-- <img src="/images/web.svg" style="width:60%"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["auth"],
};
</script>